exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customized-date-field .mat-form-field-wrapper {\n  margin-bottom: -1em; }\n\n.customized-date-field .mat-form-field-infix {\n  border-top: 0; }\n\n.ellipsed-text {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/edi/angular/app/views/oes/scanned-data/scanned-data.component.scss
// module id = ../../../../../angular/app/views/oes/scanned-data/scanned-data.component.scss
// module chunks = main